import { definePageSkill } from './definePageSkill';
import type { PageSkill } from '../types';

export const globalSkills: readonly PageSkill[] = [
  definePageSkill({
    type: 'open-url',
    description: 'Open a URL',
    execute: (skillData) => {
      window.open(skillData.url, '_blank');
    },
    responseSchema: {
      schemaDefinition: {
        url: 'The URL to open',
      },
      mandatoryFields: ['url'],
    },
  }),
];
